module.exports = [
  {
    id: "1",
    word: "أكل"
  },
  {
    id: "4",
    word: "ضوء المرور"
  },
  {
    id: "6",
    word: "ذهب"
  },
  {
    id: "7",
    word: "أحب"
  },
  {
    id: "8",
    word: "سقط"
  },
  {
    id: "10",
    word: "خبز"
  },
  {
    id: "11",
    word: "وقت"
  },
  {
    id: "28",
    word: "أب"
  },
  {
    id: "56",
    word: "درس"
  },
  {
    id: "75",
    word: "إله"
  },
  {
    id: "85",
    word: "كأس"
  },
  {
    id: "91",
    word: "نقود"
  },
  {
    id: "104",
    word: "جرى"
  },
  {
    id: "108",
    word: "رأى"
  },
  {
    id: "109",
    word: "أعطى"
  },
  {
    id: "110",
    word: "طار"
  },
  {
    id: "111",
    word: "رضيع"
  },
  {
    id: "113",
    word: "كلب"
  },
  {
    id: "127",
    word: "موت"
  },
  {
    id: "134",
    word: "نفس"
  },
  {
    id: "140",
    word: "والد"
  },
  {
    id: "146",
    word: "جحيم"
  },
  {
    id: "155",
    word: "عاش"
  },
  {
    id: "156",
    word: "اتصل"
  },
  {
    id: "157",
    word: "سمح"
  },
  {
    id: "158",
    word: "وقف"
  },
  {
    id: "159",
    word: "تمنى"
  },
  {
    id: "160",
    word: "اهتم ب"
  },
  {
    id: "175",
    word: "سيدة"
  },
  {
    id: "176",
    word: "عنق"
  },
  {
    id: "184",
    word: "حلاق"
  },
  {
    id: "186",
    word: "حقل"
  },
  {
    id: "188",
    word: "ظهيرة"
  },
  {
    id: "193",
    word: "حانة"
  },
  {
    id: "198",
    word: "صيف"
  },
  {
    id: "200",
    word: "صمت"
  },
  {
    id: "203",
    word: "تمشى"
  },
  {
    id: "208",
    word: "أخبر"
  },
  {
    id: "209",
    word: "أراد"
  },
  {
    id: "230",
    word: "لون"
  },
  {
    id: "243",
    word: "غرفة النوم"
  },
  {
    id: "249",
    word: "حشد"
  },
  {
    id: "250",
    word: "محطة المترو"
  },
  {
    id: "260",
    word: "فاز"
  },
  {
    id: "261",
    word: "دمعة"
  },
  {
    id: "265",
    word: "وسط"
  },
  {
    id: "267",
    word: "متجر"
  },
  {
    id: "270",
    word: "حذء"
  },
  {
    id: "273",
    word: "قارورة"
  },
  {
    id: "275",
    word: "منتج"
  },
  {
    id: "287",
    word: "رسكل"
  },
  {
    id: "296",
    word: "رفيق السكن"
  },
  {
    id: "298",
    word: "أسد"
  },
  {
    id: "301",
    word: "آلم"
  },
  {
    id: "309",
    word: "لعب"
  },
  {
    id: "314",
    word: "مثلجات"
  },
  {
    id: "316",
    word: "ملاحظة"
  },
  {
    id: "339",
    word: "درج"
  },
  {
    id: "344",
    word: "ذهب"
  },
  {
    id: "351",
    word: "اعجب ب"
  },
  {
    id: "353",
    word: "بكى"
  },
  {
    id: "356",
    word: "قاد"
  },
  {
    id: "364",
    word: "حاسوب"
  },
  {
    id: "381",
    word: "شرطي"
  },
  {
    id: "390",
    word: "منتزه"
  },
  {
    id: "392",
    word: "زوج"
  },
  {
    id: "409",
    word: "طلب"
  },
  {
    id: "428",
    word: "فريق"
  },
  {
    id: "432",
    word: "ارسل"
  },
  {
    id: "435",
    word: "ملصق"
  },
  {
    id: "447",
    word: "دخن"
  },
  {
    id: "455",
    word: "استخدم"
  },
  {
    id: "456",
    word: "ركب الدراجة"
  },
  {
    id: "457",
    word: "قتل"
  },
  {
    id: "459",
    word: "قص"
  },
  {
    id: "461",
    word: "وزن"
  },
  {
    id: "462",
    word: "لسان"
  },
  {
    id: "499",
    word: "معلم"
  },
  {
    id: "521",
    word: "صورة"
  },
  {
    id: "522",
    word: "فقط"
  },
  {
    id: "541",
    word: "سفرة"
  },
  {
    id: "545",
    word: "هاتف محمول"
  },
  {
    id: "549",
    word: "اثلج"
  },
  {
    id: "550",
    word: "تفصيل"
  },
  {
    id: "553",
    word: "حادث"
  },
  {
    id: "555",
    word: "هاجم"
  },
  {
    id: "557",
    word: "أحب"
  },
  {
    id: "558",
    word: "أمسك"
  },
  {
    id: "562",
    word: "الخريف"
  },
  {
    id: "563",
    word: "ضيف"
  },
  {
    id: "578",
    word: "تطبيق"
  },
  {
    id: "581",
    word: "انسان"
  },
  {
    id: "587",
    word: "جمال"
  },
  {
    id: "590",
    word: "أشخاص"
  },
  {
    id: "591",
    word: "رسم"
  },
  {
    id: "606",
    word: "جادل"
  },
  {
    id: "607",
    word: "جمد"
  },
  {
    id: "619",
    word: "ملعب"
  },
  {
    id: "627",
    word: "صالة التمارين"
  },
  {
    id: "628",
    word: "من"
  },
  {
    id: "633",
    word: "الأمس"
  },
  {
    id: "634",
    word: "خاطئ"
  },
  {
    id: "651",
    word: "خان"
  },
  {
    id: "658",
    word: "كون"
  },
  {
    id: "663",
    word: "قرار"
  },
  {
    id: "685",
    word: "عدو"
  },
  {
    id: "689",
    word: "أيّ"
  },
  {
    id: "694",
    word: "صحة"
  },
  {
    id: "697",
    word: "لوحة"
  },
  {
    id: "706",
    word: "قاس"
  },
  {
    id: "711",
    word: "ذئب"
  },
  {
    id: "713",
    word: "قميص"
  },
  {
    id: "714",
    word: "ساعة"
  },
  {
    id: "716",
    word: "شريط قياس"
  },
  {
    id: "723",
    word: "بأيّ تواتر"
  },
  {
    id: "725",
    word: "كم"
  },
  {
    id: "733",
    word: "سرعة"
  },
  {
    id: "742",
    word: "رجل الثلج"
  },
  {
    id: "763",
    word: "قسم"
  },
  {
    id: "765",
    word: "جريمة قتل"
  },
  {
    id: "767",
    word: "ثاني"
  },
  {
    id: "776",
    word: "سعر"
  },
  {
    id: "779",
    word: "بداية"
  },
  {
    id: "780",
    word: "صيدلي"
  },
  {
    id: "789",
    word: "ميزان"
  },
  {
    id: "794",
    word: "سحّاب"
  },
  {
    id: "797",
    word: "شيء"
  },
  {
    id: "798",
    word: "يافع"
  },
  {
    id: "802",
    word: "صاد"
  },
  {
    id: "807",
    word: "استحم"
  },
  {
    id: "822",
    word: "رف"
  },
  {
    id: "825",
    word: "فولاذ"
  },
  {
    id: "827",
    word: "لعبة"
  },
  {
    id: "830",
    word: "لاعب"
  },
  {
    id: "832",
    word: "وسادة"
  },
  {
    id: "834",
    word: "درج"
  },
  {
    id: "836",
    word: "مفتش"
  },
  {
    id: "845",
    word: "اجاص"
  },
  {
    id: "856",
    word: "أجاب"
  },
  {
    id: "857",
    word: "أدار"
  },
  {
    id: "861",
    word: "يخت"
  },
  {
    id: "866",
    word: "طاؤوس"
  },
  {
    id: "868",
    word: "مؤلف"
  },
  {
    id: "869",
    word: "موظف"
  },
  {
    id: "873",
    word: "ألقى"
  },
  {
    id: "885",
    word: "روبوت"
  },
  {
    id: "888",
    word: "قيوطي"
  },
  {
    id: "889",
    word: "بطاطس"
  },
  {
    id: "895",
    word: "ولادة"
  },
  {
    id: "903",
    word: "أتلف"
  },
  {
    id: "913",
    word: "شرف"
  },
  {
    id: "918",
    word: "أفضلية"
  },
  {
    id: "919",
    word: "مساعد"
  },
  {
    id: "920",
    word: "ابهام"
  },
  {
    id: "921",
    word: "مستطيل"
  },
  {
    id: "929",
    word: "أطلق النار"
  },
  {
    id: "940",
    word: "عجلة"
  },
  {
    id: "941",
    word: "شاهد"
  },
  {
    id: "955",
    word: "أزعج"
  },
  {
    id: "956",
    word: "فاوض"
  },
  {
    id: "968",
    word: "مثير للإهتمام"
  },
  {
    id: "972",
    word: "مسيرة"
  },
  {
    id: "984",
    word: "توأم"
  },
  {
    id: "989",
    word: "كرة المضرب"
  },
  {
    id: "991",
    word: "إصابة"
  },
  {
    id: "994",
    word: "أنبوب"
  },
  {
    id: "996",
    word: "افق"
  },
  {
    id: "998",
    word: "ظرف"
  },
  {
    id: "1000",
    word: "بالغ"
  },
  {
    id: "1002",
    word: "تنصت"
  },
  {
    id: "1003",
    word: "طلب"
  },
  {
    id: "1005",
    word: "أغرى"
  },
  {
    id: "1008",
    word: "احرج"
  },
  {
    id: "1009",
    word: "القى نطرة"
  },
  {
    id: "1011",
    word: "خط"
  },
  {
    id: "1013",
    word: "بطن"
  },
  {
    id: "1014",
    word: "منزل"
  },
  {
    id: "1015",
    word: "صرّف"
  },
  {
    id: "1017",
    word: "أرجوحة"
  },
  {
    id: "1018",
    word: "دافع عن نفسه"
  },
  {
    id: "1020",
    word: "بلح البحر"
  },
  {
    id: "1021",
    word: "مجتمع"
  },
  {
    id: "1022",
    word: "نقطة"
  },
  {
    id: "1023",
    word: "شريط"
  },
  {
    id: "1027",
    word: "فيديو"
  },
  {
    id: "1028",
    word: "سلة"
  },
  {
    id: "1030",
    word: "محاولة"
  },
  {
    id: "1031",
    word: "ربطة عنق"
  },
  {
    id: "1036",
    word: "عام"
  },
  {
    id: "1037",
    word: "جذر"
  },
  {
    id: "1041",
    word: "فأر"
  },
  {
    id: "1043",
    word: "معنى"
  },
  {
    id: "1045",
    word: "أمر"
  },
  {
    id: "1047",
    word: "عارضة أزياء"
  },
  {
    id: "1048",
    word: "دبابة"
  },
  {
    id: "1050",
    word: "مروحة"
  },
  {
    id: "1052",
    word: "نبتة"
  },
  {
    id: "1055",
    word: "تجاوز"
  },
  {
    id: "1063",
    word: "شقة"
  },
  {
    id: "1067",
    word: "معدات"
  },
  {
    id: "1076",
    word: "خدعة"
  },
  {
    id: "1077",
    word: "قدر"
  },
  {
    id: "1079",
    word: "حول"
  },
  {
    id: "1081",
    word: "حلوى"
  },
  {
    id: "1082",
    word: "حبل"
  },
  {
    id: "1089",
    word: "لغم ارضي"
  },
  {
    id: "1093",
    word: "ضاعف"
  },
  {
    id: "1094",
    word: "مسدس"
  },
  {
    id: "1096",
    word: "خيم"
  },
  {
    id: "1099",
    word: "السادس عشر"
  },
  {
    id: "1100",
    word: "الثامن"
  },
  {
    id: "1102",
    word: "صارع"
  },
  {
    id: "1103",
    word: "العلوم الجينية"
  },
  {
    id: "1106",
    word: "خاط"
  },
  {
    id: "1109",
    word: "مسك"
  },
  {
    id: "1111",
    word: "الة صرف نقود"
  },
  {
    id: "1117",
    word: "قبعة"
  },
  {
    id: "1130",
    word: "طرح"
  },
  {
    id: "1132",
    word: "قرن"
  },
  {
    id: "1135",
    word: "دمية"
  },
  {
    id: "1136",
    word: "التسلق"
  },
  {
    id: "1140",
    word: "المراهقة"
  },
  {
    id: "1141",
    word: "نفخ"
  },
  {
    id: "1143",
    word: "غطى"
  },
  {
    id: "1146",
    word: "الشريف"
  },
  {
    id: "1149",
    word: "نظرية"
  },
  {
    id: "1150",
    word: "قدّم"
  },
  {
    id: "1153",
    word: "أطال النوم"
  },
  {
    id: "1158",
    word: "انتقم"
  },
  {
    id: "1160",
    word: "محب"
  },
  {
    id: "1164",
    word: "جيل"
  },
  {
    id: "1165",
    word: "سلطة"
  },
  {
    id: "1170",
    word: "قاتل"
  },
  {
    id: "1171",
    word: "أداة"
  },
  {
    id: "1173",
    word: "زيارة"
  },
  {
    id: "1174",
    word: "الطلب"
  },
  {
    id: "1181",
    word: "شخر"
  },
  {
    id: "1188",
    word: "غرفة الأطفال"
  },
  {
    id: "1194",
    word: "قفاز الفرن"
  },
  {
    id: "1195",
    word: "الأمعاء الغليظة"
  },
  {
    id: "1199",
    word: "العلاقة"
  },
  {
    id: "1202",
    word: "أغوى"
  },
  {
    id: "1208",
    word: "نبح"
  },
  {
    id: "1210",
    word: "فر"
  },
  {
    id: "1215",
    word: "خلية النحل "
  },
  {
    id: "1216",
    word: "انعطف"
  },
  {
    id: "1227",
    word: "المجرية"
  },
  {
    id: "1240",
    word: "ثعبان البحر"
  },
  {
    id: "1246",
    word: "لوحة ألوان الرسام"
  },
  {
    id: "1248",
    word: "عصب"
  },
  {
    id: "1252",
    word: "أنّ"
  },
  {
    id: "1254",
    word: "تماشى"
  },
  {
    id: "1257",
    word: "رش"
  },
  {
    id: "1263",
    word: "الدهن"
  },
  {
    id: "1267",
    word: "قرض ائتمان"
  },
  {
    id: "1275",
    word: "قدم بقشيشا"
  },
  {
    id: "1293",
    word: "ريشة"
  },
  {
    id: "1297",
    word: "سمين"
  },
  {
    id: "1301",
    word: "عذب"
  },
  {
    id: "1302",
    word: "نقل"
  },
  {
    id: "1303",
    word: "قلى"
  },
  {
    id: "1309",
    word: "ملك"
  },
  {
    id: "1319",
    word: "شبكة العنكبوت"
  },
  {
    id: "1321",
    word: "قفل"
  },
  {
    id: "1332",
    word: "امريكي"
  },
  {
    id: "1337",
    word: "المرسى"
  },
  {
    id: "1338",
    word: "جدول"
  },
  {
    id: "1343",
    word: "قضمة"
  },
  {
    id: "1345",
    word: "معروف"
  },
  {
    id: "1354",
    word: "الدقيق"
  },
  {
    id: "1355",
    word: "طلق"
  },
  {
    id: "1356",
    word: "رفع"
  },
  {
    id: "1359",
    word: "انخفض"
  },
  {
    id: "1360",
    word: "صلى"
  },
  {
    id: "1361",
    word: "عقار"
  },
  {
    id: "1366",
    word: "المجر"
  },
  {
    id: "1368",
    word: "سلة"
  },
  {
    id: "1371",
    word: "شعاع"
  },
  {
    id: "1375",
    word: "حرك"
  },
  {
    id: "1381",
    word: "برتقالة"
  },
  {
    id: "1394",
    word: "بركة"
  },
  {
    id: "1399",
    word: "زوجة الأب"
  },
  {
    id: "1406",
    word: "أرّق"
  },
  {
    id: "1407",
    word: "طارد"
  },
  {
    id: "1411",
    word: "رن"
  },
  {
    id: "1412",
    word: "الأكل"
  },
  {
    id: "1425",
    word: "قطرة"
  },
  {
    id: "1436",
    word: "شارك الطريق"
  },
  {
    id: "1438",
    word: "فرح"
  },
  {
    id: "1444",
    word: "اكليل"
  },
  {
    id: "1451",
    word: "وحد"
  },
  {
    id: "1456",
    word: "عرّف"
  },
  {
    id: "1457",
    word: "قاد"
  },
  {
    id: "1458",
    word: "انصهر"
  },
  {
    id: "1459",
    word: "اهان"
  },
  {
    id: "1466",
    word: "الة"
  },
  {
    id: "1486",
    word: "حي"
  },
  {
    id: "1506",
    word: "تجرأ"
  },
  {
    id: "1513",
    word: "بذرة"
  },
  {
    id: "1516",
    word: "سروال قصير"
  },
  {
    id: "1529",
    word: "مشهور"
  },
  {
    id: "1538",
    word: "موقف"
  },
  {
    id: "1540",
    word: "دُوَّامَة الخَيْل"
  },
  {
    id: "1545",
    word: "التعليمات"
  },
  {
    id: "1556",
    word: "غش"
  },
  {
    id: "1567",
    word: "مرهق"
  },
  {
    id: "1573",
    word: "ارجوحة"
  },
  {
    id: "1577",
    word: "مبلل"
  },
  {
    id: "1582",
    word: "طبيعي"
  },
  {
    id: "1589",
    word: "مفتوح"
  },
  {
    id: "1594",
    word: "فطيرة"
  },
  {
    id: "1603",
    word: "غلّى"
  },
  {
    id: "1604",
    word: "قبل"
  },
  {
    id: "1606",
    word: "وصل"
  },
  {
    id: "1613",
    word: "جاذبية"
  },
  {
    id: "1622",
    word: "الإنجيل"
  },
  {
    id: "1625",
    word: "الأدغال"
  },
  {
    id: "1633",
    word: "فاتح العلب"
  },
  {
    id: "1647",
    word: "دقيق"
  },
  {
    id: "1651",
    word: "قاطع"
  },
  {
    id: "1653",
    word: "جفف"
  },
  {
    id: "1659",
    word: "الفنون القتالية"
  },
  {
    id: "1660",
    word: "نادى"
  },
  {
    id: "1665",
    word: "الفكاهة"
  },
  {
    id: "1677",
    word: "أولووية"
  },
  {
    id: "1679",
    word: "بني"
  },
  {
    id: "1702",
    word: "مزح"
  },
  {
    id: "1706",
    word: "مرض بحمى"
  },
  {
    id: "1707",
    word: "فرك"
  },
  {
    id: "1709",
    word: "أفاق"
  },
  {
    id: "1714",
    word: "القشرة"
  },
  {
    id: "1716",
    word: "حاد"
  },
  {
    id: "1718",
    word: "بندقية الرش"
  },
  {
    id: "1719",
    word: "التقييم"
  },
  {
    id: "1724",
    word: "ثقيل"
  },
  {
    id: "1729",
    word: "مؤكد"
  },
  {
    id: "1735",
    word: "ربطة العنق"
  },
  {
    id: "1744",
    word: "حاف"
  },
  {
    id: "1752",
    word: "الليلة"
  },
  {
    id: "1753",
    word: "بصق"
  },
  {
    id: "1765",
    word: "نقطة"
  },
  {
    id: "1767",
    word: "غريب"
  },
  {
    id: "1776",
    word: "معرض"
  },
  {
    id: "1774",
    word: "محبب"
  },
  {
    id: "1785",
    word: "السمعة"
  },
  {
    id: "1799",
    word: "كافئ"
  },
  {
    id: "1802",
    word: "مستثمر"
  },
  {
    id: "1803",
    word: "سخن"
  },
  {
    id: "1804",
    word: "حرك"
  },
  {
    id: "1806",
    word: "إجهاض"
  },
  {
    id: "1809",
    word: "خاف"
  },
  {
    id: "1810",
    word: "تمطط"
  },
  {
    id: "1818",
    word: "مصحة"
  },
  {
    id: "1819",
    word: "اشهار"
  },
  {
    id: "1828",
    word: "حضن"
  },
  {
    id: "1831",
    word: "مخطط دراسي"
  },
  {
    id: "1847",
    word: "مسرور"
  },
  {
    id: "1848",
    word: "الجوارب الطويلة "
  },
  {
    id: "1851",
    word: "شفى"
  },
  {
    id: "1854",
    word: "عبأ"
  },
  {
    id: "1857",
    word: "امتطى"
  },
  {
    id: "1858",
    word: "كلف"
  },
  {
    id: "1859",
    word: "اقترض"
  },
  {
    id: "1878",
    word: "كلفة"
  },
  {
    id: "1881",
    word: "مخلوق"
  },
  {
    id: "1890",
    word: "فرقة موسيقية"
  },
  {
    id: "1894",
    word: "ضريبة"
  },
  {
    id: "1896",
    word: "صورة"
  },
  {
    id: "1901",
    word: "سعل"
  },
  {
    id: "1903",
    word: "دب قطبي"
  },
  {
    id: "1904",
    word: "مضرب"
  },
  {
    id: "1907",
    word: "تعرق"
  },
  {
    id: "1910",
    word: "ساعة الإيقاف"
  },
  {
    id: "1911",
    word: "بطولة"
  },
  {
    id: "1912",
    word: "الكف"
  },
  {
    id: "1926",
    word: "الممر"
  },
  {
    id: "1935",
    word: "ادعاء"
  },
  {
    id: "1939",
    word: "رخصة"
  },
  {
    id: "1942",
    word: "فوضى"
  },
  {
    id: "1944",
    word: "خزانة"
  },
  {
    id: "1946",
    word: "قصير"
  },
  {
    id: "1951",
    word: "اعلم"
  },
  {
    id: "1953",
    word: "نمى"
  },
  {
    id: "1956",
    word: "انجز"
  },
  {
    id: "1958",
    word: "احسّ"
  },
  {
    id: "1963",
    word: "المد"
  },
  {
    id: "1967",
    word: "يدعى"
  },
  {
    id: "1968",
    word: "رامي السهام"
  },
  {
    id: "1986",
    word: "بعض الشيء"
  },
  {
    id: "1987",
    word: "صاروخ"
  },
  {
    id: "1988",
    word: "أخلاقي"
  },
  {
    id: "1989",
    word: "لطيف"
  },
  {
    id: "2004",
    word: "خدم"
  },
  {
    id: "2006",
    word: "مشى"
  },
  {
    id: "2008",
    word: "ملاحة"
  },
  {
    id: "2012",
    word: "جلب الانتباه"
  },
  {
    id: "2018",
    word: "قرصان"
  },
  {
    id: "2019",
    word: "وصف"
  },
  {
    id: "2028",
    word: "عبقري"
  },
  {
    id: "2031",
    word: "تشكيلة"
  },
  {
    id: "2033",
    word: "إقامة"
  },
  {
    id: "2034",
    word: "رداء"
  },
  {
    id: "2039",
    word: "متصل"
  },
  {
    id: "2040",
    word: "التطور"
  },
  {
    id: "2042",
    word: "انيق"
  },
  {
    id: "2043",
    word: "نشيط"
  },
  {
    id: "2047",
    word: "ظهر"
  },
  {
    id: "2051",
    word: "استلم"
  },
  {
    id: "2052",
    word: "غير متناسب"
  },
  {
    id: "2053",
    word: "يعاكس"
  },
  {
    id: "2054",
    word: "تحدى"
  },
  {
    id: "2055",
    word: "احتل"
  },
  {
    id: "2057",
    word: "عض"
  },
  {
    id: "2059",
    word: "عرض"
  },
  {
    id: "2060",
    word: "سعى"
  },
  {
    id: "2063",
    word: "جراحة"
  },
  {
    id: "2067",
    word: "قطعة"
  },
  {
    id: "2070",
    word: "قميص"
  },
  {
    id: "2081",
    word: "صفارة"
  },
  {
    id: "2086",
    word: "جذري"
  },
  {
    id: "2101",
    word: "غرق"
  },
  {
    id: "2103",
    word: "احتوى"
  },
  {
    id: "2104",
    word: "اضاء"
  },
  {
    id: "2106",
    word: "اندهش"
  },
  {
    id: "2107",
    word: "صفر"
  },
  {
    id: "2110",
    word: "يشبه"
  },
  {
    id: "2111",
    word: "القسم"
  },
  {
    id: "2115",
    word: "الهرولة"
  },
  {
    id: "2119",
    word: "محرج"
  },
  {
    id: "2121",
    word: "موقع"
  },
  {
    id: "2129",
    word: "مقياس"
  },
  {
    id: "2132",
    word: "رقّع"
  },
  {
    id: "2134",
    word: "اسطورة"
  },
  {
    id: "2135",
    word: "عواقب"
  },
  {
    id: "2142",
    word: "عينة"
  },
  {
    id: "2145",
    word: "جزاز المروج"
  },
  {
    id: "2151",
    word: "بوابة"
  },
  {
    id: "2152",
    word: "ساموراي"
  },
  {
    id: "2153",
    word: "ثنى"
  },
  {
    id: "2154",
    word: "طعن"
  },
  {
    id: "2158",
    word: "افطر"
  },
  {
    id: "2159",
    word: "لون"
  },
  {
    id: "2163",
    word: "مجرفة"
  },
  {
    id: "2164",
    word: "مستودع"
  },
  {
    id: "2167",
    word: "طماع"
  },
  {
    id: "2168",
    word: "اضاءة"
  },
  {
    id: "2176",
    word: "فرقة"
  },
  {
    id: "2174",
    word: "حاليا"
  },
  {
    id: "2185",
    word: "مقزز"
  },
  {
    id: "2186",
    word: "كومة"
  },
  {
    id: "2187",
    word: "مصور"
  },
  {
    id: "2191",
    word: "وحيد"
  },
  {
    id: "2201",
    word: "لمع"
  },
  {
    id: "2202",
    word: "صلح"
  },
  {
    id: "2203",
    word: "قدر"
  },
  {
    id: "2206",
    word: "سحق"
  },
  {
    id: "2207",
    word: "مبارزة"
  },
  {
    id: "2210",
    word: "قسم"
  },
  {
    id: "2221",
    word: "عرض"
  },
  {
    id: "2226",
    word: "الإجراء"
  },
  {
    id: "2229",
    word: "صرخة"
  },
  {
    id: "2231",
    word: "برعم"
  },
  {
    id: "2239",
    word: "كیلومتر"
  },
  {
    id: "2241",
    word: "ابله"
  },
  {
    id: "2245",
    word: "انقاض"
  },
  {
    id: "2250",
    word: "متعصب"
  },
  {
    id: "2253",
    word: "سافر"
  },
  {
    id: "2255",
    word: "ربط"
  },
  {
    id: "2262",
    word: "الدرجة في الأولى"
  },
  {
    id: "2267",
    word: "رسمي"
  },
  {
    id: "2269",
    word: "نخلة"
  },
  {
    id: "2270",
    word: "امبراطورية"
  },
  {
    id: "2278",
    word: "عنقود"
  },
  {
    id: "2284",
    word: "مات"
  },
  {
    id: "2286",
    word: "نسر"
  },
  {
    id: "2289",
    word: "إشارة"
  },
  {
    id: "2295",
    word: "جرى"
  },
  {
    id: "2296",
    word: "تعديل"
  },
  {
    id: "2301",
    word: "ناسب"
  },
  {
    id: "2304",
    word: "حك"
  },
  {
    id: "2305",
    word: "میلمتر"
  },
  {
    id: "2310",
    word: "غمر"
  },
  {
    id: "2311",
    word: "بقعة"
  },
  {
    id: "2313",
    word: "يائس"
  },
  {
    id: "2318",
    word: "الجنة"
  },
  {
    id: "2327",
    word: "مبتهج"
  },
  {
    id: "2331",
    word: "الكلفة"
  },
  {
    id: "2336",
    word: "حبر"
  },
  {
    id: "2341",
    word: "بخّر"
  },
  {
    id: "2352",
    word: "سحر"
  },
  {
    id: "2354",
    word: "لبس"
  },
  {
    id: "2355",
    word: "كذب"
  },
  {
    id: "2358",
    word: "كسر"
  },
  {
    id: "2361",
    word: "شق"
  },
  {
    id: "2370",
    word: "عذراء"
  },
  {
    id: "2375",
    word: "تخزين"
  },
  {
    id: "2376",
    word: "نظافة"
  },
  {
    id: "2377",
    word: "مأساة"
  },
  {
    id: "2379",
    word: "فیروز"
  },
  {
    id: "2381",
    word: "محاسب"
  },
  {
    id: "2383",
    word: "جوهرة"
  },
  {
    id: "2385",
    word: "هجأ"
  },
  {
    id: "2386",
    word: "صمد"
  },
  {
    id: "2387",
    word: "خريطة"
  },
  {
    id: "2391",
    word: "اذا"
  },
  {
    id: "2392",
    word: "بؤبؤ"
  },
  {
    id: "2401",
    word: "صَر "
  },
  {
    id: "2403",
    word: "نظر"
  },
  {
    id: "2404",
    word: "فاجأ"
  },
  {
    id: "2406",
    word: "لاقى"
  },
  {
    id: "2408",
    word: "غرس"
  },
  {
    id: "2413",
    word: "مضاد حيوي"
  },
  {
    id: "2415",
    word: "إهليج"
  },
  {
    id: "2425",
    word: "مسودة"
  },
  {
    id: "2432",
    word: "عشبة"
  },
  {
    id: "2432",
    word: "جذع"
  },
  {
    id: "2334",
    word: "قنبلة"
  },
  {
    id: "2441",
    word: "حاد"
  },
  {
    id: "2443",
    word: "سجل الدخول"
  },
  {
    id: "2447",
    word: "لقاء"
  },
  {
    id: "2451",
    word: "قادر"
  },
  {
    id: "2453",
    word: "لاقى"
  },
  {
    id: "2455",
    word: "برّد"
  },
  {
    id: "2456",
    word: "آمأ"
  },
  {
    id: "2460",
    word: "قطر"
  },
  {
    id: "2462",
    word: "بعيد"
  },
  {
    id: "2464",
    word: "الجوز"
  },
  {
    id: "2466",
    word: "لوّح"
  },
  {
    id: "2488",
    word: "سجل الخروج"
  },
  {
    id: "2502",
    word: "شهّر ب"
  },
  {
    id: "2508",
    word: "مجفف الملابس"
  },
  {
    id: "2511",
    word: "الصمود"
  },
  {
    id: "2512",
    word: "سرير"
  },
  {
    id: "2516",
    word: "مراقبة"
  },
  {
    id: "2519",
    word: "شفرة الحلاقة"
  },
  {
    id: "2522",
    word: "بركة"
  },
  {
    id: "2523",
    word: "التيار الكهربائي"
  },
  {
    id: "2532",
    word: "صك"
  },
  {
    id: "2538",
    word: "كرامة"
  },
  {
    id: "2546",
    word: "قاطع التذاكر"
  },
  {
    id: "2547",
    word: "أفرج"
  },
  {
    id: "2551",
    word: "دين"
  },
  {
    id: "2553",
    word: "بقايا"
  },
  {
    id: "2556",
    word: "سباح منقذ"
  },
  {
    id: "2565",
    word: "حلق متورم"
  },
  {
    id: "2572",
    word: "الرحيل"
  },
  {
    id: "2582",
    word: "المحطة الأخيرة"
  },
  {
    id: "2585",
    word: "غير منتهي"
  },
  {
    id: "2592",
    word: "قس"
  },
  {
    id: "2591",
    word: "حتمي"
  },
  {
    id: "2595",
    word: "متجر"
  },
  {
    id: "2596",
    word: "أعمال خيرية"
  },
  {
    id: "2606",
    word: "مافيا"
  },
  {
    id: "2613",
    word: "حمّالات "
  },
  {
    id: "2620",
    word: "صدرية"
  },
  {
    id: "2622",
    word: "طلب"
  },
  {
    id: "2630",
    word: "أرق"
  },
  {
    id: "2631",
    word: "كرة"
  },
  {
    id: "2633",
    word: "خيال"
  },
  {
    id: "2636",
    word: "تقنية"
  },
  {
    id: "2637",
    word: "مؤشر"
  },
  {
    id: "2638",
    word: "مطعم جامعي"
  },
  {
    id: "2639",
    word: "مريض"
  },
  {
    id: "2643",
    word: "نقطتان"
  },
  {
    id: "2644",
    word: "سوار"
  },
  {
    id: "2646",
    word: "حمية"
  },
  {
    id: "2649",
    word: "عكس"
  },
  {
    id: "2657",
    word: "معرفة"
  },
  {
    id: "2884",
    word: "لحم"
  },
  {
    id: "2661",
    word: "متزامن"
  },
  {
    id: "2668",
    word: "مَنِيع"
  },
  {
    id: "2677",
    word: "جازف"
  },
  {
    id: "2682",
    word: "مكب النفايات"
  },
  {
    id: "2699",
    word: "كلمات"
  },
  {
    id: "2701",
    word: "معلاق"
  },
  {
    id: "2704",
    word: "مشروب كحولي"
  },
  {
    id: "2705",
    word: "عصارة"
  },
  {
    id: "2706",
    word: "اعتقل"
  },
  {
    id: "2708",
    word: "غاص"
  },
  {
    id: "2712",
    word: "خدش"
  },
  {
    id: "2730",
    word: "عمود"
  },
  {
    id: "2732",
    word: "دقة الشاشة"
  },
  {
    id: "2738",
    word: "مرة"
  },
  {
    id: "2741",
    word: "تسجيل"
  },
  {
    id: "2748",
    word: "طَرِيّ "
  },
  {
    id: "2752",
    word: "السحلبية "
  },
  {
    id: "2753",
    word: "انفجار"
  },
  {
    id: "2769",
    word: "بعوضة"
  },
  {
    id: "2770",
    word: "نرد"
  },
  {
    id: "2772",
    word: "منشفة"
  },
  {
    id: "2776",
    word: "اختلاف "
  },
  {
    id: "2777",
    word: "مُنْفَتِح"
  },
  {
    id: "2784",
    word: "حارس الغابة"
  },
  {
    id: "2785",
    word: "معالم"
  },
  {
    id: "2787",
    word: "مرضي"
  },
  {
    id: "2791",
    word: "مشوى"
  },
  {
    id: "2797",
    word: "انهى"
  },
  {
    id: "2798",
    word: "مباشرة"
  },
  {
    id: "2805",
    word: "مشمول"
  },
  {
    id: "2806",
    word: "مثقاب"
  },
  {
    id: "2813",
    word: "مرساة"
  },
  {
    id: "2816",
    word: "مأسوي"
  },
  {
    id: "2819",
    word: "العرض"
  },
  {
    id: "2822",
    word: "فصيح"
  },
  {
    id: "2825",
    word: "عيد الشكر"
  },
  {
    id: "2830",
    word: "إضافي"
  },
  {
    id: "2831",
    word: "بعيد"
  },
  {
    id: "2838",
    word: "غنيمة"
  },
  {
    id: "2855",
    word: "زميل الدراسة"
  },
  {
    id: "2864",
    word: "اثارة"
  },
  {
    id: "2865",
    word: "الريف"
  },
  {
    id: "2866",
    word: "تقريبا"
  },
  {
    id: "2874",
    word: "إعلان"
  },
  {
    id: "2878",
    word: "افتراضي"
  },
  {
    id: "2882",
    word: "مسرح"
  },
  {
    id: "2892",
    word: "جهاز المشي"
  },
  {
    id: "2904",
    word: "خادم"
  },
  {
    id: "2912",
    word: "كرتونة"
  },
  {
    id: "2914",
    word: "سياسي"
  },
  {
    id: "2921",
    word: "لطيف"
  },
  {
    id: "2926",
    word: "صبور"
  },
  {
    id: "2934",
    word: "الناسخ الضوئي"
  },
  {
    id: "2943",
    word: "شمال شرقي"
  },
  {
    id: "2944",
    word: "لوحة منجمية"
  },
  {
    id: "2950",
    word: "أيض"
  },
  {
    id: "2956",
    word: "منشار"
  },
  {
    id: "2955",
    word: "طوافة"
  },
  {
    id: "2959",
    word: "مميز"
  },
  {
    id: "2968",
    word: "عاتم"
  },
  {
    id: "2971",
    word: "خصم"
  },
  {
    id: "2974",
    word: "إحْسان"
  },
  {
    id: "2982",
    word: "تذكير"
  },
  {
    id: "2986",
    word: "حمّل"
  },
  {
    id: "2992",
    word: "ولاعة"
  },
  {
    id: "2993",
    word: "بائِخ"
  },
  {
    id: "2999",
    word: "العولمة"
  },
  {
    id: "3005",
    word: "عكس"
  },
  {
    id: "3006",
    word: "تنشيط"
  },
  {
    id: "3009",
    word: "انقص"
  },
  {
    id: "3014",
    word: "اليونان"
  },
  {
    id: "3016",
    word: "مشجع"
  },
  {
    id: "3025",
    word: "صحيح"
  },
  {
    id: "3029",
    word: "خطوبة"
  },
  {
    id: "3030",
    word: "مجازف"
  },
  {
    id: "3034",
    word: "مترجل"
  },
  {
    id: "3047",
    word: "صنارة"
  },
  {
    id: "3051",
    word: "طباخ"
  },
  {
    id: "3053",
    word: "إعصار"
  },
  {
    id: "3061",
    word: "فاقد الصبر"
  },
  {
    id: "3062",
    word: "أعمى"
  },
  {
    id: "3073",
    word: "صحح"
  },
  {
    id: "3074",
    word: "نسخة"
  },
  {
    id: "3075",
    word: "شفاهي"
  },
  {
    id: "3077",
    word: "حسّن"
  },
  {
    id: "3085",
    word: "تابع"
  },
  {
    id: "3089",
    word: "الشهرة"
  },
  {
    id: "3090",
    word: "المبشرة"
  },
  {
    id: "3091",
    word: "معيوب"
  },
  {
    id: "3091",
    word: "معيوب"
  },
  {
    id: "3096",
    word: "صندوق"
  },
  {
    id: "3101",
    word: "في الطريق"
  },
  {
    id: "3106",
    word: "مختلف"
  },
  {
    id: "3110",
    word: "الانتخاب"
  },
  {
    id: "3114",
    word: "شوكة"
  },
  {
    id: "3119",
    word: "قرض"
  },
  {
    id: "3120",
    word: "اشتغل"
  },
  {
    id: "3114",
    word: "فزاعة"
  },
  {
    id: "3125",
    word: "عَلَف"
  },
  {
    id: "3126",
    word: "مشغول"
  },
  {
    id: "3129",
    word: "احتفال"
  },
  {
    id: "3132",
    word: "توزيع الأدوار"
  },
  {
    id: "3141",
    word: "حفرة"
  },
  {
    id: "3142",
    word: "صعب"
  },
  {
    id: "3145",
    word: "كامل"
  },
  {
    id: "3146",
    word: "رصين"
  },
  {
    id: "3147",
    word: "ممسحة"
  },
  {
    id: "3150",
    word: "معلم"
  },
  {
    id: "3152",
    word: "لوازم المائدة "
  },
  {
    id: "3156",
    word: "عملة افتراضية"
  },
  {
    id: "3162",
    word: "هورمون"
  },
  {
    id: "3164",
    word: "حركة نسائية داعية إلى المساواة بين الجنسين "
  },
  {
    id: "3168",
    word: "مُرْشِد"
  },
  {
    id: "3171",
    word: "تَقْطِيب"
  },
  {
    id: "3173",
    word: "عجوز"
  },
  {
    id: "3174",
    word: "ابتلع"
  },
  {
    id: "3188",
    word: "في اخارج"
  },
  {
    id: "3196",
    word: "قانوني"
  },
  {
    id: "3199",
    word: "امتطى"
  },
  {
    id: "3200",
    word: "خرج من"
  },
  {
    id: "3202",
    word: "التأمل"
  },
  {
    id: "3203",
    word: "مُجَمّد"
  },
  {
    id: "3209",
    word: "جُزَيْء"
  },
  {
    id: "3222",
    word: "معلم"
  },
  {
    id: "3225",
    word: "المملكة العربية السعودية"
  },
  {
    id: "3230",
    word: "شارع احادي الاتجاه"
  },
  {
    id: "3231",
    word: "ماهر"
  },
  {
    id: "3234",
    word: "ضيق"
  },
  {
    id: "3235",
    word: "طابع بريدي"
  },
  {
    id: "3236",
    word: "جسيمة"
  },
  {
    id: "3240",
    word: "قاسٍ"
  },
  {
    id: "3241",
    word: " نشيط"
  },
  {
    id: "3244",
    word: "ورق المرحاض"
  },
  {
    id: "3247",
    word: "ابريق"
  },
  {
    id: "3248",
    word: "كنية"
  },
  {
    id: "3249",
    word: "فانيلا"
  },
  {
    id: "3255",
    word: "دَلِيل"
  },
  {
    id: "3260",
    word: "فهم"
  },
  {
    id: "3261",
    word: "اخ"
  },
  {
    id: "3264",
    word: "فريد"
  },
  {
    id: "3267",
    word: "الهوائی"
  },
  {
    id: "3269",
    word: "مظلة"
  },
  {
    id: "3273",
    word: "نظم"
  },
  {
    id: "3279",
    word: "حقا"
  },
  {
    id: "3284",
    word: "مضاد للماء"
  },
  {
    id: "3287",
    word: "سداسي"
  },
  {
    id: "3295",
    word: "عجينة"
  },
  {
    id: "3296",
    word: "لاحظ"
  },
  {
    id: "3306",
    word: "شهري"
  },
  {
    id: "3309",
    word: "جبان"
  },
  {
    id: "3310",
    word: "نادي"
  },
  {
    id: "3312",
    word: "مسطح"
  },
  {
    id: "3313",
    word: "مثار"
  },
  {
    id: "3314",
    word: "زوج الأم"
  },
  {
    id: "3315",
    word: "تأمل"
  },
  {
    id: "3318",
    word: "سترة"
  },
  {
    id: "3327",
    word: "متلازمة"
  },
  {
    id: "3329",
    word: "السكري"
  },
  {
    id: "3335",
    word: "وافق على"
  },
  {
    id: "3337",
    word: "جرافة"
  },
  {
    id: "3339",
    word: "رائد أعمال"
  },
  {
    id: "3348",
    word: "سد"
  },
  {
    id: "3353",
    word: "عشوائي"
  },
  {
    id: "3354",
    word: "زين"
  },
  {
    id: "3355",
    word: "وثائقي"
  },
  {
    id: "3357",
    word: "ذكي"
  },
  {
    id: "3358",
    word: "استبيان"
  },
  {
    id: "3363",
    word: "سرير الطفل"
  },
  {
    id: "3366",
    word: "عطر"
  },
  {
    id: "3369",
    word: "جيّد"
  },
  {
    id: "3370",
    word: "ميدان"
  },
  {
    id: "3371",
    word: "الترجمة المكتوبة"
  },
  {
    id: "3376",
    word: "كتيّب"
  },
  {
    id: "3379",
    word: "مستحضر السمرة"
  },
  {
    id: "3381",
    word: "قرب"
  },
  {
    id: "3382",
    word: "حذاء مطاطي"
  },
  {
    id: "3389",
    word: "سنويا"
  },
  {
    id: "3392",
    word: "اخفى"
  },
  {
    id: "3397",
    word: "باقة"
  },
  {
    id: "3403",
    word: "شغب"
  },
  {
    id: "3407",
    word: "عصفور دُورِيّ "
  },
  {
    id: "3412",
    word: "وصفة طبية"
  },
  {
    id: "3430",
    word: "يوميا"
  },
  {
    id: "3432",
    word: "دائري"
  },
  {
    id: "3437",
    word: "تعافي"
  },
  {
    id: "3448",
    word: "مشغّل"
  },
  {
    id: "3449",
    word: "مؤهل"
  },
  {
    id: "3455",
    word: "وافق"
  },
  {
    id: "3461",
    word: "مخبزة"
  },
  {
    id: "3469",
    word: "إعتبار"
  },
  {
    id: "3470",
    word: "ترامبولين"
  },
  {
    id: "3474",
    word: "راعي"
  },
  {
    id: "3476",
    word: "عاد"
  },
  {
    id: "3477",
    word: "آجر"
  },
  {
    id: "3484",
    word: "مسترخي"
  },
  {
    id: "3485",
    word: "متشرد"
  },
  {
    id: "3486",
    word: "زمام"
  },
  {
    id: "3487",
    word: "مطلق"
  },
  {
    id: "3488",
    word: "خطيب"
  },
  {
    id: "3492",
    word: "مر"
  }
];



// WEBPACK FOOTER //
// ./src/containers/Words/ar.js